import type { BoxTruckMyDriverCompanyDepositDto } from '@numeo/types-core'

export interface QuickViewField {
    label: string
    value?: string | number | null
}

/** The existing quick-view field grid renders these with the same copyable tiles as every other group. */
export const myDriverCompanyDepositGroups = ({ company, deposit }: BoxTruckMyDriverCompanyDepositDto) => [
    {
        title: 'Company Details',
        fields: [
            { label: 'Company Name', value: company.name },
            { label: 'EIN', value: company.ein },
            { label: 'MC Number', value: company.mcNumber },
            { label: 'DOT Number', value: company.dotNumber },
            { label: 'Company Address', value: company.address },
            { label: 'Company Phone', value: company.phone },
        ] satisfies QuickViewField[],
    },
    {
        title: 'Direct Deposit',
        fields: [
            { label: 'Deposit Company Name', value: deposit.bankCompanyName },
            { label: 'Bank Name', value: deposit.bankName },
            { label: 'Account Number', value: deposit.bankAccountNumber },
            { label: 'Routing Number', value: deposit.bankRoutingNumber },
            { label: 'City, State and ZIP', value: deposit.bankAddress },
            { label: 'Street Address', value: deposit.bankStreetAddress },
        ] satisfies QuickViewField[],
    },
]
